import React from 'react'
import {isValidUrl} from "./UrlUtils";
import {booleanProp} from "./ReactUtils";
import getLogger from "./Logging.js"

const log = getLogger("ValidationUtils")

export function showError(id, v) {
  try {
    let r = true
    // console.debug(">>>Z: id=", id)
    const el = document.getElementById(id)
    const formGroupEl = el.closest(".form-group")
    if (formGroupEl) {
      if (v) {
        formGroupEl.classList.add("invalid")
        const errorEl = formGroupEl.querySelectorAll(".v-" + v)
        if (errorEl && errorEl.length > 0) {
          errorEl[0].classList.add("v-error")
        }
        r = false
      } else {
        formGroupEl.classList.remove("invalid")
      }
    }
    return r
  }
  catch (e) {
    // console.error(e)
  }
}

export function clearError(id) {
  const el = document.getElementById(id)
  if (el) {
    const formGroupEl = el.closest(".form-group")
    if (formGroupEl) {
        formGroupEl.classList.remove("invalid")
    }    
  }    
}  

export function clearAllErrors(containerId) {
  const containerEl = document.getElementById(containerId)
  if (containerEl) {
    const formGroupEls = containerEl.querySelectorAll(".form-group")
    if (formGroupEls && formGroupEls.length > 0) {
      formGroupEls.forEach(function (formGroupEl) {
        formGroupEl.classList.remove("invalid")
        const vEls = formGroupEl.querySelectorAll(".v-error")
        if (vEls && vEls.length > 0) {
          vEls.forEach(function (vEl) {
            vEl.classList.remove("v-error")
          })
        }
      })
    }
  }
}

export function validateField(id, cond, v, opt) {
  // console.debug(">>Z: validateField: id, cond, v, opt=", id, cond, v, opt)
  if (!cond) {
    opt.valid = false
    opt.focusEl = opt.focusEl || id
    showError(id, v)
  }
  else {
    clearError(id)
  }
}

const domainNameRegex = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,20})$/)

export function validateDomainName(v) {
  return isValidUrl(v)
  // return v && v.trim().length > 0 && domainNameRegex.test(v)
}

const emailAddressRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function validateEmailAddress(v) {  
  return v && v.trim().length > 0 && emailAddressRegex.test(v)
}

const validUrlPat = new RegExp('^(https:\\/\\/)?'+ // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+@!$&\'()*,;=:]*)*'+ // port and path
  '(\\?[-a-z\\d%_.~+@!$&\'()*,;=:\\/?]*)?'+ // query string
  '(\\#[-a-z\\d%_.~+@!$&\'()*,;=:\\/?]*)?$','i')

function hostMatchesDomain(hostname, domain) {
  hostname = hostname.toLowerCase()
  domain = domain.toLowerCase()
  return hostname === domain || hostname.endsWith(`.${domain}`)
}

export function validateUrl(url, options) {
  if (url) {
    if (options && (true === options.relaxed)) {
      if (!url.startsWith("https://")) {
        url = `https://${url}`
      }
    }
    try {
      const u = new URL(url)
      if (u.protocol === "https:") {
        if (validUrlPat.test(url)) {
          if (options && options.disallowedDomains && Array.isArray(options.disallowedDomains)) {
            if (options.disallowedDomains.find((d) => hostMatchesDomain(u.hostname, d))) {
              return false
            }
          }
          if (options && options.allowedDomains && Array.isArray(options.allowedDomains)) {
            if (!options.allowedDomains.find((d) => hostMatchesDomain(u.hostname, d))) {
              return false
            }
          }
          return true
        }
      }
    }
    catch (e) {
      // invalid URL
    }
  }
  return false
}

export function InfoBlock(props) {
  const className = `helptext ${props.className || ""}`
  return (
    booleanProp(props, "disabled") === false ? (
      (booleanProp(props, "ordered") === true || "ORDERED" === props?.format?.toUpperCase()) ? (
        <ol className={className}>
          {props.children}
        </ol>
      ) : (
        <ul className={className}>
          {props.children}
        </ul>
      )
    ) : (
      <></>
    )
  )
}

export function InfoText(props) {
  if (booleanProp(props, "disabled")) {
    return (<></>)
  }
  else {
    return (
      <li className={props.validate ? `v v-${props.validate}` : props.warning ? "v v-warning" : "d"}>
        <span>
          {props.children}
        </span>
      </li>
    )
  }
}
